import * as React from 'react';
import { withRouter } from 'react-router';
import injectSheet from 'react-jss';
import { Row, Col, Icon, Tooltip, Alert, Skeleton, Button, message, Checkbox } from 'antd';
import ExtendDeadlineModal from '../Modals/ExtendDeadlineModal';
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import ViewBreakdown from '../Modals/ViewBreakdown';
import {
  getInquiryDetailRoute, getInquiryEditRoute,
  getDuplicateInquiryRoute,
  bookingShipperRoute, getAddOfflineBidRoute,
} from 'src/routing/utils';
import SendRFQ from '../Modals/SendRFQ';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  getAllInquiriesResetFilter,
  getAllInquiriesApplyFilter,
  changeSelection,
} from 'src/actions/inquiryShipperActions';
import { getBidRanksShipperInquiry, fetchRejectedFFs } from 'src/api/inquiry';
import SendIcon from 'src/components/common/icons/send';
import CreateInquiryModal from '../Modals/CreateInquiryModal';
import BookingSuccessProtip from '../Modals/BookingSuccessProtip';
import PricePerContainer from '../../../common/PricePerContainer';
import ContainerDetails from './ContainerDetails/ContainerDetails';
import { fetchKYC } from '../../kycConnections/kycConnections.api';
import FFConnectionRequestKYC from '../../kycConnections/FFConnectionRequestKYC';
import { OrganisationOnboardingStatus } from '../../masters/Masters.Helper';
import { EventCategories, sendEvent } from 'src/utils/gaService';
import BookingTnCModal from '../../DiscoverRate/BookingTnCModal';
import { BookingStats, ConnectionType, InquirySource, InquiryStatus } from '../InquiryUtils';
import ExistingBookingAlertModal from '../Modals/ExistingBookingAlertModal';
import InquiryRejectedFFModal from "../Modals/InquiryRejectedFFModal";
import { InquiryModes } from 'src/Library/Constants';
import { getEmptyContainerLocation, renderInquiryOriginDetails,
  renderInquiryDestinationDetails } from './InquiryCommon';
import { commonStyles } from 'src/Library/CommonStyles';
import AdditionalEmailsForBookingModal from '../Modals/AdditionalEmailsForBookingModal';
import { isValidNumber } from 'src/Library/Helper';
import { FormComponentProps } from 'antd/lib/form';
import { disableAddOfflineBidForDomestic } from '../constants';
import { searchUser } from 'src/api/teams';
import { tokens } from 'src/design-system';

const styles = (theme: any) => ({
  iconsTheme: {
    flex: 1,
    marginBottom: `${tokens.spacing.sm}px`,
    '&:hover': {
      color: COLORS.GREEN,
    },
  },
  circle: {
    alignSelf: 'center',
    height: '18px',
    width: '18px',
    borderRadius: '9px',
    backgroundColor: '#424242',
    textAlign: 'center',
    color: tokens.colors.bgWhite,
    fontSize: '11px',
  },
  cardContainer: {
    // height: '150px',
    marginTop: `${tokens.spacing.sm}px`,
    padding: `${tokens.spacing.md}px ${tokens.spacing.md}px 13px ${tokens.spacing.md}px`,
    backgroundColor: tokens.colors.bgWhite,
    border: '1px solid #D9D9D9',
    borderRadius: `${tokens.radius.md}px`,
    position: 'relative'
  },
  colParent: {
    borderLeft: `1px solid ${tokens.colors.border}`,
    paddingLeft: '32px',
    height: '95px',
  },
  flex: {
    display: 'flex',
    flex: 1,
  },
  flexRow: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
  flexCol: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    minHeight: '85px',
  },
  absoluteData: {
    position: 'absolute',
    top: `${tokens.spacing.lg}px`,
  },
  confirmedDiv: {
    borderRadius: `${tokens.radius.md}px`,
    color: tokens.colors.bgWhite,
    fontSize: `${tokens.fontSize.small}px`,
    textAlign: 'center',
    width: '100px',
    backgroundColor: '#52C41A',
    border: '1px solid #389E0D',
  },
  inquiryNum: {
    color: '#1875F0',
    fontSize: `${tokens.fontSize.h3}px`,
    fontWeight: tokens.fontWeight.semibold,
    lineHeight: '21px',
  },
  viewBidsStyle: {
    position: 'absolute',
    right: `${tokens.spacing.ms}px`,
    fontSize: `${tokens.fontSize.caption}px`,
    color: tokens.colors.primary,
  },
  addBidBtn: {
    fontSize: `${tokens.fontSize.small}px`,
    color: tokens.colors.primary,
    cursor: 'pointer',
  },
  addBidBtnDisabled: {
    fontSize: `${tokens.fontSize.small}px`,
    color: '#D9D9D9',
    cursor: 'default',
  },
  actionsRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingLeft: '32px',
    alignItems: 'center',
  },
  internalRefStyle: {
    fontSize: `${tokens.fontSize.small}px`,
    margin: `${tokens.spacing.xs}px 0px 10px`, // Changed from '-5px 0px 10px' to positive margin
    fontWeight: tokens.fontWeight.semibold,
    width: '200px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    position: 'relative',
    zIndex: 1,
  },
  emptyContainerLocation: {
    color: '#666666',
    fontSize: `${tokens.fontSize.caption}px`,
    fontStyle: 'italic',
    padding: `${tokens.spacing.xs}px 0 0 14px`,
  },
  ellipsis: {
    width: '110px',
    ...commonStyles(theme).ellipses,
  },
  hiddenEllipsis: {
    width: '20%',
    ...commonStyles(theme).ellipses,
  },
  cardHover: {
    '& .ant-checkbox-wrapper': {
      opacity: 0,
      transition: 'opacity 0.3s',
    },
    '&:hover': {
      '& .ant-checkbox-wrapper': {
        opacity: 1,
        transition: 'opacity 0.3s',
      },
    },
  },
  highValue: {
    position: 'absolute',
    zIndex: 1,
    backgroundColor: '#1990ff',
    height: '15px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    top: '0px',
    left: '0px',
    fontSize: '8px',
    fontWeight: 'bold',
    color:'white',
    borderRadius: '2px 2px 0px 0px'
  }
});

const COLORS = {
  GREEN: '#52C41A',
  RED: '#F5222D',
  BLUE: tokens.colors.primary,
  GREY: '#D9D9D9',
};

type State = {
  newDeadline: any;
  heading: string;
  bookingId: string | undefined;
  bookingNumber: string | undefined;
  protipVisible: boolean;
  loading: boolean;
  extendDeadlineModalVisible: boolean;
  editInquiryModalVisible: boolean;
  viewBreakdownVisible: boolean;
  sendRFQVisible: boolean;
  createInquiryModalVisible: boolean;
  isFFConnectionRequestVisible: boolean;
  kycData: Array<any>;
  kycExists: boolean;
  isGeneratingBookingData: boolean;
  isBookingTnCModalVisible: boolean;
  isExistingBookingAlertVisible: boolean;
  existingBidBookingStats: BookingStats | undefined;
  existingInquiryBookingStats: BookingStats | undefined;
  isViewAllFFsRejectedVisible: boolean;
  ffsRejected: Array<any>;
  ffsModalLoading: boolean;
  isAdditionalEmailsModalVisible: boolean;
  loadingData: boolean;
};

type InquiryShipperBidsRankingData = {
  [id: string] : {
    bidsDetails: any;
    connectionStatus : any;
    totalPerUnit: any;
    totalPerUnitType: any;
    connectionType: any;
    isStrategicFF: any;
  }
}

//Not everything is in interface Props, kindly add as things change
interface Props extends FormComponentProps {
  //from redux store
  currencySymbols: any;
  containerTypes: any;
  permissions: any;
  allowSelfRaisedInquiryBid: boolean | undefined | null;
  userStatus: any;
  organisationId: string;
  selectedItems: Record<string, any>;
  timezone?: string;

  inquiryShipperBidsRankingData : InquiryShipperBidsRankingData;
  isLoadingInquiryShipperBidsRankingData: boolean;

  inquiryShipperBookingStatCountsData: any;
  isLoadinginquiryShipperBookingStatCountsData: boolean;


  //redux dispatch
  getAllInquiriesResetFilter: () => any;
  getAllInquiriesApplyFilter: () => any;
  changeSelection: (items) => void;


  //from parent component
  //add as required
  isLoading: boolean;
  cardData: any;


  //react router
  history: any;

  //form, styling
  classes: {
    [X in keyof ReturnType<typeof styles>]: string;
  };
}

class InquiryShipperCard extends React.PureComponent<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      newDeadline: null,
      heading: '',
      bookingId: '',
      bookingNumber: '',
      protipVisible: false,
      loading: false,
      extendDeadlineModalVisible: false,
      editInquiryModalVisible: false,
      viewBreakdownVisible: false,
      sendRFQVisible: false,
      createInquiryModalVisible: false,
      isFFConnectionRequestVisible: false,
      kycData: [],
      kycExists: false,
      isGeneratingBookingData: false,
      isBookingTnCModalVisible: false,
      isExistingBookingAlertVisible: false,
      existingBidBookingStats: undefined,
      existingInquiryBookingStats: undefined,
      isViewAllFFsRejectedVisible: false,
      ffsRejected: [],
      ffsModalLoading: false,
      isAdditionalEmailsModalVisible: false,
      loadingData: false,
    };
  }

  // extract bid data relevant to this inquiry from redux
  processInquiryFfBidsRankingData(inquiryId: string|number, inquiryShipperBidsRankingData: InquiryShipperBidsRankingData ) {
    const rankingData = inquiryShipperBidsRankingData?.[inquiryId]?.[0];
    return {
      bidBookingStats: rankingData?.bidsDetails?.bookingStats,
      bidRankData: rankingData?.bidsDetails,
      connectionStatus: rankingData?.connectionStatus,
      connectionType: rankingData?.connectionType,
      inquiryBookingStats: rankingData?.inquiryBookingStats,
      isStrategicFF: rankingData?.isStrategicFF,
      totalPerContainerType: rankingData?.totalPerUnitType,
    }
  }

  componentDidMount() {
    this.loadInitialData();
  }

  componentDidUpdate() {
    if ((this.props.isLoading && !this.state.loadingData)) {
      this.loadInitialData();
    }
  }

  loadInitialData = async () => {
    this.setState({ loadingData: true })
    const { deadline } = this.props.cardData;

    this.setState({
      newDeadline: deadline,
      loadingData: this.props.isLoading
    });
  }

  handleViewBids = () => {
    const { history, cardData } = this.props;
    sendEvent(
      EventCategories.INQUIRY_BID_CONFIRMATION,
      'View Bids',
    );
    history.push(`${getInquiryDetailRoute('shipper', cardData.id, 'bids')}`);
  }

  handleClickInquiryNumber = () => {
    const { id } = this.props.cardData;
    const { permissions: { INQUIRY_VIEW_BIDS_ACTIONS } } = this.props;
    if (INQUIRY_VIEW_BIDS_ACTIONS) {
      sendEvent(
        EventCategories.INQUIRY_BID_CONFIRMATION,
        'View Bids',
      );
      this.props.history.push(getInquiryDetailRoute('shipper', id, 'bids'));
    } else {
      this.props.history.push(getInquiryDetailRoute('shipper', id, 'details'));
    }
  }

  handleClickViewBreakdown = () => {
    this.setState({
      viewBreakdownVisible: true,
    });
  }

  closeViewBreakdown = () => {
    this.setState({
      viewBreakdownVisible: false,
    });
  }

  showSendRFQ = () => {
    this.setState({
      sendRFQVisible: true,
    });
  }

  hideSendRFQ = () => {
    this.setState({
      sendRFQVisible: false,
    });
  }

  onSendRFQOk = () => {
    this.hideSendRFQ();
    this.props.getAllInquiriesResetFilter();
  }

  showExtendDeadlineModal = () => {
    this.setState({
      extendDeadlineModalVisible: true,
    });
  }

  showEditInquiryModal = (heading) => {
    this.setState({
      heading,
      editInquiryModalVisible: true,
    });
  }

  extendDeadlineModalHandleOk = (newDeadline) => {
    this.setState({
      newDeadline,
      loading: true,
    });
    this.props.getAllInquiriesApplyFilter();
    this.props.changeSelection({})
    this.setState({ loading: false, extendDeadlineModalVisible: false });
    sendEvent(
      EventCategories.INQUIRY_SEND,
      'Edit Inquiry - Deadline Extended',
      'Inquiry Shipper Card'
    );
  }

  extendDeadlineModalHandleCancel = () => {
    this.setState({ extendDeadlineModalVisible: false });
  }

  editInquiryModalHandleOk = () => {
    this.setState({ editInquiryModalVisible: false });
    return <Alert message="edit ok" />;
  }

  editInquiryModalHandleCancel = () => {
    this.setState({ editInquiryModalVisible: false });
  }

  renderDot = (style, char) => {
    return <div style={{
      marginBottom: '3px', height: '8px', width: '8px',
      borderRadius: `${tokens.radius.md}px`, display: 'inline-block',
      verticalAlign: 'middle',
      ...style,
    }}><span style={{ paddingLeft: '1px' }}>{char}</span></div>;
  }

  renderFFsRejectedModal = () : React.ReactElement => {
    const { isViewAllFFsRejectedVisible, ffsRejected, ffsModalLoading } = this.state;
    return (
      <InquiryRejectedFFModal
        visible={isViewAllFFsRejectedVisible}
        handleCancel={() => this.setState({ isViewAllFFsRejectedVisible: false })}
        ffRejectedData={ffsRejected}
        loading={ffsModalLoading}
      />
    );
  };

  renderLine = (color) => {
    return <div style={{ display: 'flex', flex: 1, height: '1px', backgroundColor: color }}>
    </div>;
  }

  renderStatus = () => {
    const { cardData } = this.props;
    const deadline = moment(cardData?.deadline);
    const currentTime = moment();
    const isDeadLinePassed = deadline.isBefore(currentTime);
    const status = cardData.status === 'OPEN' && isDeadLinePassed ? 'CLOSED' : cardData.status;
    let backgroundColor;
    let statusValue;
    switch (status) {
      case 'OPEN': {
        backgroundColor = COLORS.BLUE;
        statusValue = 'Open';
        break;
      }
      case 'CONFIRMED': {
        backgroundColor = COLORS.GREEN;
        statusValue = 'Confirmed';
        break;
      }
      case 'CLOSED': {
        backgroundColor = COLORS.RED;
        statusValue = 'Closed';
        break;
      }
      default: {
        backgroundColor: COLORS.BLUE;
        statusValue: 'Open';
        break;
      }
    }
    return (
      <div style={{
        fontWeight: tokens.fontWeight.semibold, fontSize: `${tokens.fontSize.body}px`, marginTop: '3px', marginLeft: '20px',
        color: '#252323d9', bottom: 0, float: 'left',
      }}>
        {this.renderDot({
          backgroundColor,
          marginRight: '11px',
          marginLeft: '3px',
          verticalAlign: 'middle',
        }, '')}
        <span>{statusValue}</span>
      </div>)
      ;
  }

  getDeadline = () => {
    const { cardData: data, timezone } = this.props;
    const deadlineMoment = timezone && data.deadline
      ? momentTimezone(data.deadline).tz(timezone)
      : data.deadline ? moment(data.deadline) : null;
    
    const deadline = deadlineMoment 
      ? `${deadlineMoment.format('DD MMMM, YYYY | HH:mm')}Hrs` 
      : '-- : --';
    
    let deadlineString = deadline;
    let deadlineColor = '#424242';
    let isDeadlineNear = false;
    
    // For time comparisons, use UTC to ensure accuracy
    if (data.deadline && (moment(data.deadline) >= moment())) {
      if (moment(data.deadline) < moment().add(2, 'days')) {
        isDeadlineNear = true;
        const now = moment();
        const closingDate = moment(data.deadline);
        const difference = moment.duration(closingDate.diff(now));
        const hours = difference.asHours().toFixed(0);
        deadlineString = `${hours} hours left`;
        if (parseInt(hours, 10) <= 1) {
          const minutes = difference.asMinutes().toFixed(0);
          deadlineString = `${minutes} minutes left`;
        }
        deadlineColor = '#F5222D';
      }
    }

    if (!deadline) return;

    return <div style={{ fontSize: '11px', color: `${deadlineColor}` }}>
      <Tooltip title={isDeadlineNear ? deadline : ''}>
        <Icon type="hourglass" style={{ marginRight: '11px', fontSize: `${tokens.fontSize.body}px` }} />
        <span>{deadlineString}</span>
      </Tooltip>
    </div>;
  }


  getCreator = () => {
    const { creationUser } = this.props.cardData;
    return (
      <div style={{ fontSize: '11px' }}>
        <Tooltip title="Created By" placement="topRight">
          
          <Icon type="user" style={{ marginRight: '11px', fontSize: `${tokens.fontSize.body}px` }} />
        </Tooltip>
        <span style={{ color: '#424242' }}>
          {creationUser}
        </span>
      </div>
    );
  };



  handleViewAll = async () => {
    const { id: inquiryId } = this.props.cardData;
    this.setState({
      ffsModalLoading: true,
      isViewAllFFsRejectedVisible: true
    });
    const response = await fetchRejectedFFs(inquiryId);
      if (response.isSuccess) {
        this.setState({ ffsRejected: response.data })
      } else {
        message.error(response.errorMessage);
      }
      this.setState({
        ffsModalLoading: false,
      });
  }

  getCreationDate = () => {
    const { cardData: { createdAt } } = this.props;

    if (!createdAt) return null;
    return (
      <div style={{ fontSize: '11px' }}>
        <Tooltip title="Creation date and time" placement="topRight">
          <Icon type="clock-circle" style={{ marginRight: '11px', fontSize: `${tokens.fontSize.body}px` }} />
        </Tooltip>
        <span style={{ color: '424242' }}>
          {`${moment(createdAt).format('DD MMMM, YYYY | HH:mm')}Hrs`}
        </span>
      </div>
    );
  }

  renderDataCol1 = () => {
    const { classes, cardData: data } = this.props;
    
    
    return <div style={{display:'flex', flexDirection:'row'}}>
      {this.renderCheckbox()}
      <div className={classes.flexCol}>
        <div style={{ marginBottom: '8px' }}>
          <a className={classes.inquiryNum}
            onClick={this.handleClickInquiryNumber}>{data.referenceNumber}{
              data?.otherDetails?.isDraft && (
                <span style={{ fontStyle: 'italic', fontSize: `${tokens.fontSize.caption}px`, color: data?.otherDetails?.isDraftIncomplete ? '#F5222D' : '#424242' }}>
                  &nbsp;&nbsp;[DRAFT]
                </span>
              )
            }</a>
        </div>
        {data.internalReferenceNumber ? 
          <Tooltip title={data.internalReferenceNumber}>
            <div className={classes.internalRefStyle}>
              <span style={{ fontWeight:500, color: '#A7A7A7' }}>Internal # </span>
              {data.internalReferenceNumber}
            </div>
          </Tooltip> : null}
        {this.getCreationDate()}
        {this.getCreator()}
        {this.getDeadline()}
      </div>
    </div>;
  }

  getContainerType = (key) => {
    const { containerTypes } = this.props;
    if (!key || !containerTypes) return;
    const type = containerTypes.filter(item => item.key === key);
    if (type.length > 0) return type[0].label;
  }

  renderDataCol2 = () => {
    const { classes, cardData: data } = this.props;
    return (
      <div className={classes.flexRow} style={{
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '25px', marginTop: '4px',
        marginRight: '106px',
      }}>
        <div>
          {this.renderDot({ backgroundColor: COLORS.GREY }, '')}
          <div className={classes.absoluteData} style={{
            width: '20%', left: '22px',
            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
          }}>
            {renderInquiryOriginDetails(classes, data)}
          </div>
        </div>
        {this.renderLine(COLORS.GREY)}
        <ContainerDetails data={data} />
        {this.renderLine(COLORS.GREY)}
        <div>
          {this.renderDot({ border: `1px solid ${COLORS.GREY}` }, '')}
          <br />
          <div className={classes.absoluteData}
            style={{ right: (data.mode === InquiryModes.TRAILER || data.mode === InquiryModes.DOMESTIC || data.mode === 'RPTL') ? '20px' : '12px', 
            ...( (data.mode === InquiryModes.TRAILER || data.mode === InquiryModes.DOMESTIC || data.mode === 'RPTL') 
                  && {width: '20%',
                      whiteSpace: 'nowrap', 
                      overflow: 'hidden', 
                      textOverflow: 'ellipsis'
                      }
                )
              }}>
            {renderInquiryDestinationDetails(classes, data)}
          </div>
        </div>
      </div>
    );
  }

  renderDataCol3 = () => {
    const { classes, cardData: data, permissions } = this.props;
    const { INQUIRY_SEND_ACTIONS, INQUIRY_VIEW_BIDS_ACTIONS } = permissions;
    const {isViewAllFFsRejectedVisible} = this.state;
    const vendor = data.mode === InquiryModes.TRAILER || data.mode === InquiryModes.DOMESTIC || data.mode === 'RPTL' ? 'Trucker' : 'FFs';
    return (
      <div style={{ width: '100%' }}>
        {data.source === 'SPOT_SEARCH' && <Row>
          <Col span={14} style={{ fontSize: `${tokens.fontSize.small}px` }}>Pre Selected Bids </Col>
          <Col span={10} style={{ color: 'black', lineHeight: '16px' }}>
            <span style={{ fontWeight: 600 }}>{data.preSelectedBidCount}</span>
          </Col>
        </Row>}
        {INQUIRY_VIEW_BIDS_ACTIONS && <Row style={{marginTop: '4px'}}>
          <Col span={10} style={{ fontSize: `${tokens.fontSize.small}px` }}>Total Bids </Col>
          <Col span={14} style={{
            textAlign: 'left',
            fontWeight: tokens.fontWeight.semibold, color: 'black', lineHeight: '16px',
          }}>
            <span style={{ fontWeight: 600 }}>{data.totalBids}
              <a className={classes.viewBidsStyle}
                onClick={this.handleViewBids}> View Bids</a></span>
          </Col>
        </Row>}
        {INQUIRY_VIEW_BIDS_ACTIONS && <Row style={{marginTop: '4px'}}>
          <Col span={10} style={{ fontSize: `${tokens.fontSize.small}px` }}>Confirmed Bids </Col>
          <Col span={14} style={{
            textAlign: 'left',
            fontWeight: tokens.fontWeight.semibold, color: 'black', lineHeight: '16px',
          }}>
            <span style={{ fontWeight: 600 }}>{isValidNumber(data?.totalConfirmedBids)? data.totalConfirmedBids : "-" }
            </span>
          </Col>
        </Row>}
        {data.source !== 'SPOT_SEARCH' && INQUIRY_SEND_ACTIONS && <Row style={{marginTop: '4px'}}>
          <Col span={15} style={{ fontSize: `${tokens.fontSize.small}px` }}>{vendor} Accepted Inquiry </Col>
          <Col span={9} style={{ color: 'black', lineHeight: '16px' }}>
            <span style={{ fontWeight: 600 }}>{data.ffsRespondedCount}/{data.ffsSentCount}</span>
          </Col>
        </Row>}
        {INQUIRY_SEND_ACTIONS && <Row style={{marginTop: '4px'}}>
          <Col span={15} style={{ fontSize: `${tokens.fontSize.small}px` }}>{vendor} Declined Inquiry</Col>
          <Col span={9} style={{ color: 'black', lineHeight: '16px' }}>
            <span style={{ fontWeight: 600 }}>{data.ffsRejectedCount}/{data.ffsSentCount}</span>
            {
              data.ffsRejectedCount ? (
                <a className={classes.viewBidsStyle}
                    onClick={this.handleViewAll}> View All
                </a>
              ): null
            }
          </Col>
        </Row>}
        {data.source !== 'SPOT_SEARCH' && !INQUIRY_SEND_ACTIONS && !INQUIRY_VIEW_BIDS_ACTIONS &&
          <div style={{ textAlign: 'center', width: '93%' }} >
            <Skeleton title={false} paragraph={{ rows: 3 }} />
        </div>
        }
        <Row style={{ position: 'absolute', marginTop: '4px' }}>
          <div style={{ fontSize: `${tokens.fontSize.small}px` }}>{data.incoterm ? 'Incoterm' : ''}</div>
          <div style={{ fontSize: `${tokens.fontSize.body}px`, color: 'black', fontWeight: 600 }}>
            {data.incoterm ? data.incoterm : ''} {data.pickupAndDrop ?
              `(${data.pickupAndDrop})` : ''}
          </div>
        </Row>
        {isViewAllFFsRejectedVisible && INQUIRY_SEND_ACTIONS && this.renderFFsRejectedModal()}
      </div>
    );
  }

  renderDataCol4 = () => {
    const { classes, cardData, inquiryShipperBidsRankingData, isLoadingInquiryShipperBidsRankingData, permissions } = this.props;
    const { INQUIRY_SEND_ACTIONS, INQUIRY_VIEW_BIDS_ACTIONS } = permissions;
    const { bidRankData } = this.processInquiryFfBidsRankingData(cardData?.id, inquiryShipperBidsRankingData);
    if (isLoadingInquiryShipperBidsRankingData && INQUIRY_VIEW_BIDS_ACTIONS) {
      return <div style={{ textAlign: 'center', width: '100%' }} >
        <Skeleton active title={false} paragraph={{ rows: 3 }} />
      </div>;
    }
    if (cardData.ffsSentCount === 0 && INQUIRY_SEND_ACTIONS) {
      const isDomesticMode = InquiryModes.DOMESTIC === cardData?.mode || 'RPTL' === cardData?.mode;
      return <div style={{ fontSize: '15px', fontWeight: 600 }} >
        Send Inquiry to {isDomesticMode ? 'Trucker' : 'FF'} to receive bids.
      </div>;
    }
    if ((cardData.ffsRespondedCount === 0 || !bidRankData) && INQUIRY_VIEW_BIDS_ACTIONS) {
      return <div style={{ fontSize: '15px', fontWeight: 600 }} >
        There is no bid received yet.
      </div>;
    }
    if (!INQUIRY_VIEW_BIDS_ACTIONS) {
      return <div style={{ textAlign: 'center', width: '100%' }} >
        <Skeleton title={false} paragraph={{ rows: 3 }} />
      </div>;
    }
    return (
      <>
        <Col span={24}>
          <Row>
            {bidRankData && bidRankData.isConfirmed ?
              <div className={classes.confirmedDiv}>
                Confirmed Bid
              </div>
              :
              <div style={{ fontSize: `${tokens.fontSize.caption}px` }}>
                {bidRankData && bidRankData.bidStatus}
              </div>
            }
          </Row>
          <Row>
            <Col span={12} >
              <div style={{ fontSize: `${tokens.fontSize.h3}px`, color: 'black' }}>
                <PricePerContainer
                  amount={bidRankData.totalPerUnit && bidRankData.totalPerUnit.amount}
                  currency={bidRankData.totalPerUnit && bidRankData.totalPerUnit.currency}
                  perLabel={bidRankData.totalPerUnit && bidRankData.totalPerUnit.format}
                  containerTypes={bidRankData.totalPerUnitType}
                  containerDetails={cardData.containerDetails ||
                    cardData.inquiryContainerDetails}
                  totalPrice={cardData?.exchangeRate?.referenceDate ? bidRankData.userTotalWithoutTax : bidRankData.shipperTotalWithoutTax}
                  freightPerUnit={bidRankData.freightPerUnit}
                  mode={cardData.mode}
                  sourceObjectType={'INQUIRY'} />
                <div style={{ fontSize: `${tokens.fontSize.caption}px`, color: 'black' }}>
                  {bidRankData.ffName}
                </div>
              </div>
            </Col>
            <Col span={12} >
              <div style={{ height: '40px' }}>
                <img src={bidRankData.shippingLineLogoUrl} />
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <>
                <a style={{ fontSize: `${tokens.fontSize.caption}px`, color: tokens.colors.primary, margin: '15px 0px 0px 0px' }}
                  onClick={this.handleClickViewBreakdown}>
                  View Breakdown</a>
                {this.state.viewBreakdownVisible && <ViewBreakdown
                  mode={cardData?.mode}
                  type={'SHIPPER'}
                  bidId={bidRankData.id}
                  inquiryId={cardData.id}
                  visible={this.state.viewBreakdownVisible}
                  handleCancel={this.closeViewBreakdown}
                  handleOk={this.closeViewBreakdown} />}
              </>
            </Col>
          </Row>
        </Col>
      </>
    );
  }

  renderColumn = (span, elem, renderBorder = true, styles = {}) => {
    const { classes } = this.props;
    return <Col span={span} style={{ display: 'flex', flex: 1, ...styles }}
      className={renderBorder ? classes.colParent : undefined}>
      {elem}
    </Col>;
  }

  handleChangeSelection = (id: string, isSelected: boolean) => {
    const {selectedItems, cardData} = this.props;
    const newSelection = { ...selectedItems };
    if (isSelected) newSelection[cardData.id] = cardData;
    else delete newSelection[cardData.id];
    this.props.changeSelection(newSelection);
  }

  renderCheckbox = () => {
    const {selectedItems, cardData} = this.props;
    if (!selectedItems) return null;
    return <Checkbox
      style={{ marginRight: '5px' }}
      checked = {selectedItems[cardData.id]}
      onChange={e => this.handleChangeSelection(cardData.id, e.target.checked)}
    />;
  };

  handleProtipClose = () => {
    this.setState({
      protipVisible: false,
    });
    this.props.history.push(bookingShipperRoute());
  }

  redirectToBooking = () => {
    this.handleProtipClose();
  }

  handleOpenCreateBookingModal = () => {
    sendEvent(
      EventCategories.INQUIRY_BOOKING_SHIPPER,
      'Book Now - Clicked',
      'Inquiry Card',
    );
    this.setState({
      createInquiryModalVisible: true,
    });
  }

  handleCloseCreateBookingModal = (bookingNumber = undefined, bookingId = undefined) => {
    sendEvent(
      EventCategories.INQUIRY_BOOKING_SHIPPER,
      'Book Now - Cancel',
      'Inquiry Card',
    );
    this.setState({
      bookingNumber,
      bookingId,
      createInquiryModalVisible: false,
      protipVisible: bookingNumber ? true : false,
      isFFConnectionRequestVisible: false,
    });
  }

  renderIcons = () => {
    const { classes, cardData, permissions, userStatus } = this.props;
    const { INQUIRY_CREATE_UPDATE_ACTIONS } = permissions;
    const { newDeadline } = this.state;
    const isOpenEnabled = (cardData.status === 'OPEN' ? true : false);
    const isConfirmEnabled = (cardData.status === 'CONFIRMED' ? true : false);
    const isExtendDeadlineDisabled = isConfirmEnabled || !INQUIRY_CREATE_UPDATE_ACTIONS;
    const isEditDisabled = userStatus !== 'INTERNAL' &&
      (isConfirmEnabled || (cardData.ffsSentCount !== 0 && cardData.totalBids !== 0) || 
      !INQUIRY_CREATE_UPDATE_ACTIONS || cardData.status === 'CLOSED');
    const styleEdit = isEditDisabled ? {
      color: COLORS.GREY,
    } : { cursor: 'pointer' };
    const styleExtendDeadline = isExtendDeadlineDisabled ? {
      color: COLORS.GREY,
    } : { cursor: 'pointer' };
    const styleSendInquiry = isOpenEnabled ? {
      fill: COLORS.GREEN,
      marginTop: '17px',
      cursor: 'pointer',
    } : { fill: COLORS.GREY, marginTop: '17px' };
    return (
      <Col span={1}>
        <div style={{
          display: 'flex', flexDirection: 'column', marginLeft: '10px',
          fontSize: `${tokens.fontSize.h3}px`, alignItems: 'flex-end',
        }}>
          <Tooltip title={isEditDisabled ? !INQUIRY_CREATE_UPDATE_ACTIONS ? 'Permission Required' : '' : 'Edit'} placement="left">
            <Icon type="edit"
              className={classes.iconsTheme}
              style={styleEdit}
              onClick={() => {
                this.props.changeSelection({});
                const { history } = this.props;
                (isEditDisabled) ?
                  null : history.push(getInquiryEditRoute(cardData.id), 'shipper');
              }
              }
            />
          </Tooltip>
          <Tooltip title={isExtendDeadlineDisabled ? !INQUIRY_CREATE_UPDATE_ACTIONS ? 'Permission Required' : '' : 'Extend Deadline'}
            placement="left">
            <Icon type="calendar"
              className={classes.iconsTheme}
              style={styleExtendDeadline}
              onClick={((isExtendDeadlineDisabled) ?
                undefined : this.showExtendDeadlineModal)} />
          </Tooltip>
          <Tooltip title={INQUIRY_CREATE_UPDATE_ACTIONS ? 'Create Duplicate' : !INQUIRY_CREATE_UPDATE_ACTIONS ? 'Permission Required' : ''}
            placement="left">
            <Icon type="copy" style={!INQUIRY_CREATE_UPDATE_ACTIONS ? styleEdit : undefined}
              className={classes.iconsTheme}
              onClick={() => {
                const { history } = this.props;
                if (INQUIRY_CREATE_UPDATE_ACTIONS) history.push(getDuplicateInquiryRoute(cardData.id), 'shipper');
              }}
            />
          </Tooltip>
          {this.state.sendRFQVisible && (
            <SendRFQ
              referenceNumber={cardData.referenceNumber}
              sentFfIds={cardData.sentFfIds}
              deadline={cardData.deadline}
              inquiryId={cardData.id}
              inquiryMode={cardData.mode}
              visible={this.state.sendRFQVisible}
              handleOk={this.onSendRFQOk}
              handleCancel={this.hideSendRFQ}
            />
          )}
          {this.state.extendDeadlineModalVisible && (
            <ExtendDeadlineModal
              sailingDate={cardData.mode === InquiryModes.TRAILER ? cardData.cargoReadyDate : cardData.preferredSailingEnddate}
              deadline={cardData.deadline}
              inquiryId={cardData.id}
              shipperId={cardData.shipperId}
              visible={this.state.extendDeadlineModalVisible}
              handleOk={this.extendDeadlineModalHandleOk}
              handleCancel={this.extendDeadlineModalHandleCancel}
            />
          )}
        </div>
      </Col>
    );
  }

  handleAddOfflineBid = () => {
    const { history, cardData } = this.props;
    sendEvent(
      EventCategories.INQUIRY_BIDDING,
      'Add Offline Bid - Clicked',
      'Inquiry Dashboard - Shipper',
    );
    history.push(getAddOfflineBidRoute(cardData.id), 'shipper');
  }

  handleBookNow = async () => {
    const {cardData, inquiryShipperBidsRankingData } = this.props;
    const { connectionStatus } = this.processInquiryFfBidsRankingData(cardData?.id, inquiryShipperBidsRankingData);    

    if (connectionStatus === OrganisationOnboardingStatus.BLACKLISTED_ME) {
      message.error('Forwarder is not accepting the booking on this rate. Inconvenience is deeply regretted.');
      sendEvent(
        EventCategories.INQUIRY_BOOKING_SHIPPER,
        'Book Now - Failed (Blacklisted)',
        'Inquiry Card',
      );
      return;
    }
    if (connectionStatus === OrganisationOnboardingStatus.NON_LINKED ||
      connectionStatus === OrganisationOnboardingStatus.REJECTED_ME) {
      this.setState({ isGeneratingBookingData: true });
      const response = await fetchKYC();
      if (!response.isSuccess) {
        message.error(response.errorMessage)
        this.setState({ isGeneratingBookingData: false });
      } else {
        this.setState({
          isFFConnectionRequestVisible: true,
          kycData: response.data?.kycData,
          kycExists: response.data?.kycExists,
          isGeneratingBookingData: false,
        });
      }
    } else {
      this.handleOpenCreateBookingModal()
    }
  }

  renderBookingTncModal = () : React.ReactElement => {
    const { isBookingTnCModalVisible } = this.state;
    const {cardData, inquiryShipperBidsRankingData } = this.props;
    const { bidRankData } = this.processInquiryFfBidsRankingData(cardData?.id, inquiryShipperBidsRankingData);
    return (
      <BookingTnCModal
        isVisible={isBookingTnCModalVisible}
        carrierCode={bidRankData.carrier}
        onAccept={() => {
          this.setState({ isBookingTnCModalVisible: false });
          this.handleBookNow();
        }}
        onDecline={() => this.setState({ isBookingTnCModalVisible: false })}
      />
    );
  };

  handleBookNowButtonClick = () => {
    const { cardData, inquiryShipperBidsRankingData, inquiryShipperBookingStatCountsData } = this.props;
    const { source, mode, id } = cardData;
    const { connectionType, isStrategicFF } = this.processInquiryFfBidsRankingData(id, inquiryShipperBidsRankingData);
    const statCounts = inquiryShipperBookingStatCountsData?.[id];

    // Check if there are existing bookings using inquiryShipperBookingStatCountsData
    if (statCounts && (statCounts.openBookings > 0 || statCounts.successfulBookings > 0)) {
      // Map statCounts to BookingStats format for the modal
      const inquiryBookingStats: BookingStats = {
        cancelled: statCounts.cancelledBookings || 0,
        confirmed: statCounts.successfulBookings || 0,
        declined: statCounts.declinedBookings || 0,
        open: statCounts.openBookings || 0,
      };
      this.setState({
        existingBidBookingStats: undefined,
        existingInquiryBookingStats: inquiryBookingStats,
        isExistingBookingAlertVisible: true,
      });
      return;
    }

    this.proceedWithBooking(source, mode, connectionType, isStrategicFF);
  }

  proceedWithBooking = (source: string, mode: string, connectionType: string, isStrategicFF: boolean) => {
    if ((
          source === InquirySource.SPOT_SEARCH ||
          source === InquirySource.SPOT_SEARCH_ZERO_RESULTS ||
          connectionType === ConnectionType.SPOT_CONNECTION ||
          isStrategicFF
    ) && mode === 'FCL') {
      this.setState({ isBookingTnCModalVisible: true });
      return;
    }
    this.handleBookNow();
  }

  handleExistingBookingAlertProceed = () => {
    const { cardData, inquiryShipperBidsRankingData } = this.props;
    const { source, mode, id } = cardData;
    const { connectionType, isStrategicFF } = this.processInquiryFfBidsRankingData(id, inquiryShipperBidsRankingData);

    this.setState({ isExistingBookingAlertVisible: false });
    this.proceedWithBooking(source, mode, connectionType, isStrategicFF);
  }

  renderExistingBookingAlertModal = (): React.ReactElement => {
    const { existingBidBookingStats, existingInquiryBookingStats, isExistingBookingAlertVisible } = this.state;
    return (
      <ExistingBookingAlertModal
        bidBookingStats={existingBidBookingStats}
        inquiryBookingStats={existingInquiryBookingStats}
        isVisible={isExistingBookingAlertVisible}
        onCancel={() => this.setState({ isExistingBookingAlertVisible: false })}
        onProceed={this.handleExistingBookingAlertProceed}
      />
    );
  }

  renderActions = () => {
    const { classes, cardData, permissions, allowSelfRaisedInquiryBid, isLoadingInquiryShipperBidsRankingData, inquiryShipperBookingStatCountsData } = this.props;
    const { INQUIRY_ALL_ACTIONS, INQUIRY_SEND_ACTIONS } = permissions;
    const statCounts = inquiryShipperBookingStatCountsData?.[cardData?.id];
    const isDeadLinePassed = moment(cardData?.deadline).isBefore(moment());
    const isOpenEnabled = (cardData.status === InquiryStatus.OPEN ? true : false);
    const isConfirmEnabled = (cardData.status === InquiryStatus.CONFIRMED ? true : false);
    const isDomesticMode = cardData.mode === InquiryModes.DOMESTIC || cardData.mode === InquiryModes.RPTL;
    const isDraft = cardData?.otherDetails?.isDraft;
    const organisationId = this.props.organisationId;

    return (
      <div className={classes.actionsRow}>
        {cardData.ffsSentCount !== 0 && allowSelfRaisedInquiryBid && INQUIRY_ALL_ACTIONS
        && (isDomesticMode && disableAddOfflineBidForDomestic ? false : true )
        ?
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div 
            className={!isDeadLinePassed ? classes.addBidBtn : classes.addBidBtnDisabled} 
            onClick={() => !isDeadLinePassed ? this.handleAddOfflineBid() : undefined}>
            <Icon type="plus" style={{ marginRight: '5px' }} />
            <Tooltip title="Allows you to add rates on behalf of your vendors"
              mouseEnterDelay={0.5}>
              Add Offline Bid
            </Tooltip></div>
        </div> : <div></div>}
        {(isConfirmEnabled) ?
          <div
            style={{
              display: 'flex',
            }}>
            { (statCounts && ( isValidNumber(statCounts?.openBookings) || isValidNumber(statCounts?.successfulBookings))) &&
              <Tooltip title={<div
                style={{ display: 'flex', flexDirection: 'column' }}>
                  <span> Bookings Requested: {statCounts?.openBookings} </span>
                  <span> Booked : {statCounts?.successfulBookings} </span>
                </div>}>
                <div className={classes.circle}>
                  {statCounts?.openBookings + statCounts?.successfulBookings}
                </div>
              </Tooltip> }
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div>
                <Button type="primary" size="small"
                  onClick={() => INQUIRY_ALL_ACTIONS ? this.handleBookNowButtonClick() : undefined}
                  style={{
                    border: tokens.colors.primary,
                    backgroundColor: (INQUIRY_ALL_ACTIONS ? tokens.colors.primary : '#D9D9D9'),
                    fontSize: `${tokens.fontSize.caption}px`, marginLeft: '4px',
                    pointerEvents: (!INQUIRY_ALL_ACTIONS ? 'none' : undefined),
                    cursor: (!INQUIRY_ALL_ACTIONS ? 'pointer' : undefined),
                    textShadow: 'none',
                  }}
                  disabled={isLoadingInquiryShipperBidsRankingData || !INQUIRY_ALL_ACTIONS}
                >
                  Book Now
                </Button>
              </div>
            </div>
          </div> :
          INQUIRY_SEND_ACTIONS && (cardData.shipperId === organisationId) ? 
          <div>
            <Button
              type="primary"
              size="small"
              onClick={(isOpenEnabled && INQUIRY_SEND_ACTIONS && !isDraft ? this.showSendRFQ : undefined)}
              style={{
                backgroundColor: (isOpenEnabled && INQUIRY_SEND_ACTIONS && !isDraft ? tokens.colors.primary : '#D9D9D9'),
                fontSize: `${tokens.fontSize.caption}px`,
                border: tokens.colors.primary,
                pointerEvents: (!isOpenEnabled || !INQUIRY_SEND_ACTIONS ? 'none' : undefined),
                cursor: (!isOpenEnabled || !INQUIRY_SEND_ACTIONS ? 'pointer' : undefined),
                display: 'flex',
                alignItems: 'center',
              }}>
              <span style={{ lineHeight: '18px', marginRight: '-5px', textShadow: 'none' }}>
                Send Inquiry
              </span>
              <SendIcon style={{
                fill: 'white', width: '15px', height: '15px',
                transform: 'scale(0.8)', marginLeft: '0px',
              }}/>
            </Button>
          </div> : <div></div>}
      </div>
    );
  }

  render() {
    const { cardData: data, classes, inquiryShipperBidsRankingData } = this.props;
    const { createInquiryModalVisible, isFFConnectionRequestVisible,
      isGeneratingBookingData, kycExists, kycData, isBookingTnCModalVisible } = this.state;
    const { bidRankData } = this.processInquiryFfBidsRankingData(data?.id, inquiryShipperBidsRankingData);
    const ffOrganisation = {
      id: bidRankData?.ffId,
      name: bidRankData?.ffName,
    };
    return (
      <div style={
        ((data.status === InquiryStatus.CONFIRMED) ? { border: `1px solid ${COLORS.GREEN}` } : undefined)}
        className={`${classes.cardContainer} ${Object.keys(this.props.selectedItems).length > 0 ? null : classes.cardHover}`}>
        {data?.otherDetails?.isHighValueInsuranceRequired ? <div className={classes.highValue}>High Value Cargo</div> : null}
        <Row >
          {this.renderColumn(4, this.renderDataCol1(), false)}
          {this.renderColumn(9, this.renderDataCol2())}
          {this.renderColumn(5, this.renderDataCol3(), true, { paddingLeft: '16px' })}
          {this.renderColumn(5, this.renderDataCol4())}
          {this.renderIcons()}
        </Row>
        <Row>
          <Col span={4}>{this.renderStatus()}</Col>
          <Col span={9} className={classes.emptyContainerLocation}>
            {data.mode === InquiryModes.TRAILER &&
              data.emptyContainerLocationPortDetails?.code !== data.destinationPortDetails?.code &&
              getEmptyContainerLocation(data.type, data.emptyContainerLocationPortDetails?.name)}
          </Col>
          <Col span={5} />
          <Col span={6}>{this.renderActions()}</Col>
        </Row>
        {this.state.protipVisible &&
          <BookingSuccessProtip
            bookingId={this.state.bookingNumber}
            visible={this.state.protipVisible}
            handleClose={this.handleProtipClose}
            handleNotifyUsers={() => {
              this.setState({
                protipVisible: false,
                isAdditionalEmailsModalVisible: true
              })
            }}
          />
        }
        {createInquiryModalVisible &&
          <CreateInquiryModal handleCancel={this.handleCloseCreateBookingModal}
            clickedFrom="Inquiry Card"
            visible={createInquiryModalVisible} data={data} bidData={bidRankData} />}
        {isFFConnectionRequestVisible &&
        <FFConnectionRequestKYC
            isVisible={isFFConnectionRequestVisible}
            ffOrganisation={ffOrganisation}
            firstTime={!kycExists}
            kycData={kycData}
            isGeneratingBookingData={isGeneratingBookingData}
            createBooking={this.handleOpenCreateBookingModal}
            onCancel={() => this.setState({ isFFConnectionRequestVisible: false })}
          />}
        {isBookingTnCModalVisible && this.renderBookingTncModal()}
        {this.state.isExistingBookingAlertVisible && this.renderExistingBookingAlertModal()}
        {this.state.isAdditionalEmailsModalVisible && (
          <AdditionalEmailsForBookingModal
            isVisible={this.state.isAdditionalEmailsModalVisible}
            handleCancel={() => {
              this.setState({ isAdditionalEmailsModalVisible: false, protipVisible: true });
            }}
            bookingId={this.state.bookingId}
            handleSuccess={() => {
              this.setState({ isAdditionalEmailsModalVisible: false });
              this.props.history.push(
                bookingShipperRoute(),
                { successMessage: 'Booking updates have been sent successfully to users!' },
              );
            }}
          />
        )}
      </div>);
  }
}

const mapStateToProps = (state) => {
  const {
    masterData: { currencySymbols, permissions, modules, userData, timezone },
    staticData: { containerTypesKeyVal: containerTypes },
    inquiryShipperReducer
  } = state;
  return {
    currencySymbols,
    containerTypes,
    permissions,
    allowSelfRaisedInquiryBid: modules.allow_self_raised_inquiry_bid,
    userStatus: userData.status,
    organisationId: userData.organisation_id,
    timezone,
    inquiryShipperBidsRankingData : inquiryShipperReducer.inquiryShipperBidsRankingData,
    isLoadingInquiryShipperBidsRankingData : inquiryShipperReducer.isLoadingInquiryShipperBidsRankingData,
    selectedItems: inquiryShipperReducer.selectedItems,

    inquiryShipperBookingStatCountsData: inquiryShipperReducer.inquiryShipperBookingStatCountsData,
    isLoadinginquiryShipperBookingStatCountsData: inquiryShipperReducer.isLoadinginquiryShipperBookingStatCountsData,

  };
};

const mapDispatchToProps = dispatch => (bindActionCreators({
  getAllInquiriesResetFilter,
  getAllInquiriesApplyFilter,
  changeSelection,
}, dispatch));

const InquiryShipperCardStyled = injectSheet(styles)(InquiryShipperCard);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InquiryShipperCardStyled));
